
import { includesValidator } from '../../common/utils/validator';

const iconsConfig = new Map(
  [
    ['success', {
      class: 'success',
      iconName: 'approved',
      iconType: 'filled',
    }],
    ['warning', {
      class: 'warning',
      iconName: 'warning',
      iconType: 'filled',
    }],
    ['loading', {
      class: 'in-progress',
      iconName: 'spin',
      iconType: 'outlined',
    }],
    ['error', {
      class: 'warning',
      iconName: 'warning',
      iconType: 'filled',
    }],
    ['info', {
      class: 'information',
      iconName: 'information',
      iconType: 'filled',
    }],
  ],
);

const MessageTypes = {
  Warning: 'warning',
  Loading: 'loading',
  Success: 'success',
  Default: 'default',
  Info: 'info',
  Error: 'error',
};

export default {
  name: 'BbToastMessage',
  props: {
    type: {
      type: String,
      default: MessageTypes.Default,
      validator: includesValidator(MessageTypes),
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    closable: {
      type: Boolean,
      default: false,
    },
    duration: {
      type: String,
      default: '40000',
    },
  },
  computed: {
    iconConfig() {
      return this.type !== MessageTypes.Default ? iconsConfig.get(this.type) : null;
    },
    isIconsWrapperVisible() {
      return this.type !== MessageTypes.Default;
    },
    isDialogOpened: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
